// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimplePaperPodcast-cls1___ae2e723a00ec1881ade{/*!*/}.SimplePaperPodcast-cls2___c46bc53b2cd0c0e57a7{width:100%;height:40px;margin:0;padding:0;vertical-align:middle}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SimplePaperPodcast-cls1___ae2e723a00ec1881ade",
	"cls2": "SimplePaperPodcast-cls2___c46bc53b2cd0c0e57a7 SimplePaperPodcast-cls1___ae2e723a00ec1881ade"
};
export default ___CSS_LOADER_EXPORT___;
